Greenmile.GridColumns = Greenmile.GridColumns || {};

Greenmile.GridColumns.Resequence = function () {

    this.entity = null;

    this.setEntity = function (entity) {

        if (entity) {

            this.entity = entity;

        }

    };

    this.setUrl = function (url) {
        if (url) {
            this.url = url;
        }
    };

    this.getFieldsToGridLayout = async function () {

        var error  = null,
            ajax   = null;

        try {

            ajax = new Monet.Ajax();
            ajax.url = this.url;
            ajax.success = function (context) {
                return function (data) {
                    if (data) {
                        if (!App.Forms[context.entity].layout) {
                            App.Forms[context.entity].layout = {};
                        }
                        App.Forms[context.entity].layout.index = data;
                    }
                };
            }(this);

            ajax.error = function (response) {
                Monet.Configurations.errorNotification(null, response);
            };

            await ajax.send();

        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                'Error on get grid layout on route monitoring stop');
            error.console();
        }

    };

    this.getColumns = async function () {

        var error        = null,
            layout       = null,
            columns      = [],
            columnStatus = {};

        try {

            if (this.entity) {

                if (!App.Forms[this.entity].layout) {

                    App.Forms[this.entity].layout = {};

                }

                await this.getFieldsToGridLayout();

                layout = App.Forms[this.entity].layout;

                columns = Monet.Grid.getGridLayout(layout.index, this.entity);

                columnStatus.name = Monet.I18n.getResourcesByKey("PRO.Sequence");
                columnStatus.sortable = true;
                columnStatus.resizable = false;
                columnStatus.field = 'index';
                columnStatus.formatter = function (row, cell, value, column, dataContext) {

                    const { confirmed } = dataContext.model;
                    const index = dataContext.model.index + 1;
                    const icon = confirmed === undefined ? 'pending'
                               : confirmed === true      ? 'confirmed'
                               : confirmed === false     ? 'rejected'
                               : null;

                    return `<div class="resequenceCell">
                              <div class=${icon}></div>
                              <div class="text"> ${index} </div>
                            </div>`;

                };
                columnStatus.width = 130;
                columns.unshift(columnStatus);
            }

            return columns;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                'Error on get columns to resequence grid');
            error.console();
        }

    };

};
